import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import HTMLFlipBook from "react-pageflip";
import "./FlipBookViewer.css";
import { Page1Tamil } from "./pages/Page1Tamil";
import { Page1English } from "./pages/Page1English";
import { Page2English } from "./pages/Page2English";
import { Page2Tamil } from "./pages/Page2Tamil";
import { Page3Tamil } from "./pages/Page3Tamil";
import { Page3English } from "./pages/Page3English";
import { Page4Tamil } from "./pages/Page4Tamil";
import { Page4English } from "./pages/Page4English";
import { Page5Tamil } from "./pages/Page5Tamil";
import { Page5English } from "./pages/Page5English";
import { Page6Tamil } from "./pages/Page6Tamil";
import { Page6English } from "./pages/Page6English";
import { Page7Tamil } from "./pages/Page7Tamil";
import { PageEnglish7 } from "./pages/PageEnglish7";
import { Page8Tamil } from "./pages/Page8Tamil";
import { Page8English } from "./pages/Page8English";
import { Page9Tamil } from "./pages/Page9Tamil";
import { Page9English } from "./pages/Page9English";
import { Page10Tamil } from "./pages/Page10Tamil";
import { Page10English } from "./pages/Page10English";
import { Page11English } from "./pages/Page11English";
import { PageTamil11 } from "./pages/PageTamil11";
import { Page12Tamil } from "./pages/Page12Tamil";
import { Page12English } from "./pages/Page12English";

const FlipBookViewer = ({ onClose }) => {
  const [bookSize, setBookSize] = useState({ width: 600, height: 800 });

  useEffect(() => {
    const updateSize = () => {
      const width = window.innerWidth;
      if (width > 1600) {
        setBookSize({ width: 900, height: 900 });
      } else if (width > 1024) {
        setBookSize({ width: 560, height: 585 });
      } else {
        setBookSize({ width: 350, height: 500 });
      }
    };
    updateSize();
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const content = (
    <div className="flipbook-overlay">
      <button className="close-btn" onClick={onClose}>✕</button>
      <HTMLFlipBook
        width={bookSize.width}
        height={bookSize.height}
        showCover={true}
        drawShadow={true}
        className="flipbook-container"
      >
        <div className="page cover-page"></div>
        <div className="page"><Page1Tamil /></div>
        <div className="page"><Page1English /></div>
        <div className="page"><Page2Tamil /></div>
        <div className="page"><Page2English /></div>
        <div className="page"><Page3Tamil /></div>
        <div className="page"><Page3English /></div>
        <div className="page"><Page4Tamil /></div>
        <div className="page"><Page4English /></div>
        <div className="page"><Page5Tamil /></div>
        <div className="page"><Page5English /></div>
        <div className="page"><Page6Tamil /></div>
        <div className="page"><Page6English /></div>
        <div className="page"><Page7Tamil /></div>
        <div className="page"><PageEnglish7 /></div>
        <div className="page"><Page8Tamil /></div>
        <div className="page"><Page8English /></div>
        <div className="page"><Page9Tamil /></div>
        <div className="page"><Page9English /></div>
        <div className="page"><Page10Tamil /></div>
        <div className="page"><Page10English /></div>
        <div className="page"><PageTamil11 /></div>
        <div className="page"><Page11English /></div>
        <div className="page"><Page12Tamil /></div>
        <div className="page"><Page12English /></div>
      </HTMLFlipBook>
    </div>
  );

  return ReactDOM.createPortal(content, document.getElementById("flipbook-root"));
};

export default FlipBookViewer;
